import { Button } from "@mui/material";
import React, { useState } from "react";
import { T } from "../../components/T";
import AddPoleToSetModal from "../../modals/AddPoleToSetModal";

const AddPoleToSetButton = ({ setId }: { setId: string }) => {
  const [showAddDialog, setShowAddDialog] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="contained"
        color="primary"
        sx={{ mt: 3, mb: 2 }}
        onClick={() => setShowAddDialog(true)}
      >
        <T str="Add pole" />
      </Button>
      <AddPoleToSetModal
        isOpen={showAddDialog}
        close={() => setShowAddDialog(false)}
        setId={setId}
      />
    </>
  );
};

export default AddPoleToSetButton;
